import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const CheckIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper
      viewBox="0 0 20 20"
      {...props}
      fill="none"
      stroke={props.stroke ?? '#677383'}
    >
      <path
        d="M14 6.25L9 13.75L6 10.75"
        stroke="inherit"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
};
